import { InferGetStaticPropsType } from 'next';

import {
  BreadcrumbsData,
  JsonLd,
  Layout2,
  Pagination,
  PostCard,
  PostList,
  SeoData,
  SideContents,
} from '@components';
import { basePath } from '@constants';
import { getStaticProps as indexPageGetStaticProps } from '@/src/pages/knowledge';
import { postPath } from '@paths';
import { getAlternativePostPath } from '@helpers';

type Props = InferGetStaticPropsType<typeof indexPageGetStaticProps> & {
  pageCount: number;
  showFirstPostAsHeroPost?: boolean;
  loading?: boolean;
  pageTitle?: string | null;
  paginationBasePath?: string;
  seoData?: SeoData | null;
  zeroLengthMessage?: string | React.ReactElement<any> | null;
  breadcrumbs?: BreadcrumbsData;
  useHnaviHeader?: boolean;
  isHomePage?: boolean;
};

export const PostListPage: React.FC<Props> = ({
  breadcrumbs,
  categories,
  hnaviOptions,
  isHomePage,
  latestPosts,
  pageCount,
  pageNo,
  pageTitle,
  paginationBasePath = basePath,
  popularPosts,
  posts: { posts },
  seoData,
  showFirstPostAsHeroPost,
  useHnaviHeader,
  zeroLengthMessage,
  hnaviContentCategories,
}) => (
  <>
    <Layout2
      categories={categories}
      seoData={{
        ...seoData,
        metaRobotsNoindex:
          (posts?.length || 0) <= 2 ? 'noindex' : seoData?.metaRobotsNoindex,
        titlePrefix: pageNo > 1 ? `${pageNo}ページ目 ` : undefined,
      }}
      useHnaviHeader={useHnaviHeader}
      hnaviContentCategories={hnaviContentCategories}
      breadcrumbs={breadcrumbs || seoData?.breadcrumbs}
      sideBar={
        <SideContents
          categories={categories}
          latestPosts={latestPosts}
          popularPosts={popularPosts}
          fixedBanner={hnaviOptions.banners.buyerFixed}
        />
      }
      wrapLogoByH1Tag={!pageTitle}
      pageTitle={pageTitle}
    >
      {posts?.length ? (
        <PostList
          posts={posts}
          firstOneIsHeroPost={showFirstPostAsHeroPost}
          render={(post, isHeroPost) => (
            <PostCard
              alternativePostPath={getAlternativePostPath(post)}
              title={post.title}
              coverImage={post.featuredImage?.node}
              date={post.date}
              slug={post.slug}
              excerpt={post.excerpt}
              isHeroPost={isHeroPost}
              className={isHeroPost ? 'md:col-span-2' : undefined}
            />
          )}
        />
      ) : (
        zeroLengthMessage
      )}
      <Pagination pageCount={pageCount} basePath={paginationBasePath} />
    </Layout2>
    <JsonLd
      itemPaths={
        posts?.map((post) =>
          postPath(post?.slug || '', getAlternativePostPath(post))
        ) || []
      }
      includesWebSite={isHomePage}
    />
  </>
);
